import type { CommandCenterStatCard, GuidedNextActionCard } from "../adapters/guided-project-steps.js";
import { GuidedButton } from "../primitives/GuidedPrimitives.js";

export function GuidedHomeView({
  commandCenterStats,
  statsLoading,
  statsError,
  nextActions,
  onNavigate,
  onAction,
}: {
  readonly commandCenterStats: readonly CommandCenterStatCard[];
  readonly statsLoading: boolean;
  readonly statsError: string | null;
  readonly nextActions: readonly GuidedNextActionCard[];
  readonly onNavigate: (view: string, projectId?: string) => void;
  readonly onAction: (actionId: string, projectId: string) => void;
}) {
  return (
    <section className="enrein-guided-view is-active" id="view-home" aria-label="Command Center">
      <div className="enrein-guided-command-center">
        <h3 className="enrein-guided-kicker">Portfolio</h3>
        {statsError ? <p className="enrein-guided-validation">{statsError}</p> : null}
        <div className="enrein-guided-portfolio-stats" aria-busy={statsLoading}>
          {commandCenterStats.map((stat) => (
            <button
              key={stat.id}
              type="button"
              className="enrein-guided-stat-card"
              disabled={stat.navigateTo == null}
              onClick={() => {
                if (stat.navigateTo) onNavigate(stat.navigateTo);
              }}
            >
              <span className="enrein-guided-stat-card__count">{statsLoading ? "—" : stat.count}</span>
              <span className="enrein-guided-stat-card__label">{stat.label}</span>
              <span className="enrein-guided-stat-card__hint">{stat.hint}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="enrein-guided-home-entries">
        <button type="button" className="enrein-guided-entry-card" onClick={() => onNavigate("projects")}>
          <h3>Projects</h3>
          <p>See every client and open a project room.</p>
        </button>
        <button type="button" className="enrein-guided-entry-card" onClick={() => onNavigate("new")}>
          <h3>New project</h3>
          <p>Start with name, contact, type, and how to begin.</p>
        </button>
        <button type="button" className="enrein-guided-entry-card" onClick={() => onNavigate("scan")}>
          <h3>Scan existing site</h3>
          <p>Score a live URL and claim relaunch opportunities.</p>
        </button>
      </div>

      <div className="enrein-guided-next-actions">
        <h3 className="enrein-guided-kicker">Next actions</h3>
        <p className="enrein-guided-muted enrein-guided-next-actions__lead">
          One recommended step per project — open the project room to continue.
        </p>
        {nextActions.length === 0 ? (
          <p className="enrein-guided-muted">No projects yet — create one to see next actions here.</p>
        ) : (
          nextActions.map((card) => (
            <article key={card.projectId} className="enrein-guided-next-card">
              <div>
                <strong>{card.clientName}</strong>
                <h4>{card.title}</h4>
                <p className="enrein-guided-muted">{card.why}</p>
              </div>
              <GuidedButton variant="gold" onClick={() => onAction(card.actionId, card.projectId)}>
                {card.cta}
              </GuidedButton>
            </article>
          ))
        )}
      </div>
    </section>
  );
}
